module.exports = __webpack_public_path__ + "static/media/model-navara-85-4wd.cc423609.webp";